export default "__VITE_ASSET__MfeXglmI__"